/**
 * @generated SignedSource<<394265a4b78b5fa136c42c3d5d516c81>>
 * @relayHash b0304b30a3bb95bf6c9c33a987bf6502
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 230bff51677d6e64e9e9997b08ce4053a4ce484bcf1c809f98c7a33164d8942b

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useIsEligibleForContextualCollabOnboardingContentAnalyticsViewsByUserQuery$variables = {
  accountIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  contentId: string;
};
export type useIsEligibleForContextualCollabOnboardingContentAnalyticsViewsByUserQuery$data = {
  readonly contentAnalyticsViewsByUser: {
    readonly pageViews: ReadonlyArray<{
      readonly lastViewedAt: string;
    }>;
  } | null | undefined;
};
export type useIsEligibleForContextualCollabOnboardingContentAnalyticsViewsByUserQuery = {
  response: useIsEligibleForContextualCollabOnboardingContentAnalyticsViewsByUserQuery$data;
  variables: useIsEligibleForContextualCollabOnboardingContentAnalyticsViewsByUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "accountIds",
    "variableName": "accountIds"
  },
  {
    "kind": "Variable",
    "name": "contentId",
    "variableName": "contentId"
  },
  {
    "kind": "Literal",
    "name": "limit",
    "value": 1
  }
],
v3 = {
  "concreteType": "ContentAnalyticsPageViewInfo",
  "kind": "LinkedField",
  "name": "pageViews",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "lastViewedAt"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useIsEligibleForContextualCollabOnboardingContentAnalyticsViewsByUserQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "ContentAnalyticsViewsByUser",
        "kind": "LinkedField",
        "name": "contentAnalyticsViewsByUser",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useIsEligibleForContextualCollabOnboardingContentAnalyticsViewsByUserQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "ContentAnalyticsViewsByUser",
        "kind": "LinkedField",
        "name": "contentAnalyticsViewsByUser",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "b0304b30a3bb95bf6c9c33a987bf6502",
    "id": "230bff51677d6e64e9e9997b08ce4053a4ce484bcf1c809f98c7a33164d8942b",
    "metadata": {},
    "name": "useIsEligibleForContextualCollabOnboardingContentAnalyticsViewsByUserQuery",
    "operationKind": "query",
    "text": "query useIsEligibleForContextualCollabOnboardingContentAnalyticsViewsByUserQuery($contentId:ID!,$accountIds:[String]){contentAnalyticsViewsByUser(contentId:$contentId,limit:1,accountIds:$accountIds){pageViews{lastViewedAt},id}}"
  }
};
})();

(node as any).hash = "b6371dfe1f821106109b0727fa093847";

export default node;
